export default __webpack_public_path__ + "static/media/Jin_LeftWaterSplash.fae3aac1.png";